module.exports = __webpack_public_path__ + "static/media/p5_6.6507afb6.jpeg";